import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { pluralizeToString } from 'lib/string/pluralize'
import { OfferPageRoomOption, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import {
  getPropertyMappedBedbankOffer,
  getPropertyPackageOptionsByRoom,
} from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Pane from 'components/Common/Pane'
import PropertyRoomCheapestOptionMobile from 'components/OfferPage/Property/MobileBookingFlow/PropertyRoomCheapestOptionMobile'
import type { RoomPackageOptions } from 'components/OfferPage/Property/singlePropertyUtils'
import BodyText from 'components/Luxkit/Typography/BodyText'
import AlwaysOnMobileStickyHeaderFilters from '../AlwaysOnMobileStickyHeaderFilters'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
`

interface Props {
  offer: App.HotelOffer;
  bedbankOffer?: App.BedbankOffer;
  packageOptionsByRoom: Array<RoomPackageOptions>;
  roomOption?: OfferPageRoomOption;
  onBack?: () => void;
  onClose: () => void;
}

function SinglePropertyRoomSelectionModal(props: Props) {
  const {
    offer,
    bedbankOffer,
    packageOptionsByRoom,
    roomOption,
    onBack,
    onClose,
  } = props

  /************************************************************************************************/
  /* STOP! Do not add any more hooks for deriving packages/rooms or options/rates to this         */
  /* component! This logic is being refactored out into selectors! If you _need_ to add new       */
  /* logic, speak to Xiao or Robert.                                                              */
  /************************************************************************************************/

  const hasRoomOption = roomOption && Object.entries(roomOption).length === 2

  return (
    <>
      <ModalHeader
        title="Select a room"
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <AlwaysOnMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <>
          {packageOptionsByRoom.length > 1 && (
            <OptionsContainer>
              <BodyText variant="small" colour="neutral-three">
                {pluralizeToString('room type', packageOptionsByRoom.length)} available
              </BodyText>
            </OptionsContainer>
          )}
          <Pane background="neutral-six">
            <VerticalSpacer gap={8}>
              {packageOptionsByRoom.map((item) => {
                if (hasRoomOption && roomOption.roomTypeId === item.roomId) {
                  return null
                }
                return (<PropertyRoomCheapestOptionMobile
                  key={item.roomId}
                  offer={offer}
                  packageViews={item.lpc}
                  bedbankViews={item.bedbank}
                  bedbankOffer={bedbankOffer}
                  detailsModalMode="room-only"
                />)
              })}
            </VerticalSpacer>
          </Pane>
        </>
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  offer: state.offer,
  bedbankOffer: getPropertyMappedBedbankOffer(state, appState),
  packageOptionsByRoom: getPropertyPackageOptionsByRoom(state, appState),
  rooms: state.rooms,
  roomOption: state.roomOption,
}), SinglePropertyRoomSelectionModal)
